import localstorage from 'local-storage-fallback';

window._define(
    'gateways/navigationPreferenceGateway',
    ['jquery', 'common/errorFactory', 'models/NavigationPreference', 'common/router', 'app/core'],
    function ($, errorFactory, NavigationPreference, router, core) {
        'use strict';
        var NavigationPreferenceNotFoundException = errorFactory('NavigationPreferenceNotFoundException'),
            navigationPreferenceGateway = {};

        navigationPreferenceGateway.LOCAL_STORAGE_KEY = 'navigationPreferences';

        navigationPreferenceGateway.findCurrentByUser = function (user) {
            var preferences = JSON.parse(localstorage.getItem(navigationPreferenceGateway.LOCAL_STORAGE_KEY)),
                key = user.isAnonymous() ? 'anonymous' : user.getId(),
                navigationPreferenceData;

            if (typeof preferences === 'undefined' ||  !preferences[key]) {
                throw new NavigationPreferenceNotFoundException();
            }

            navigationPreferenceData = preferences[key];

            if (!user.isAnonymous()) {
                navigationPreferenceData = this._getPersistedFromApp(navigationPreferenceData);
            }

            return new NavigationPreference(navigationPreferenceData);
        };

        navigationPreferenceGateway.save = function (navigationPreference, persist) {
            var currentPreferences;

            try {
                currentPreferences = JSON.parse(localstorage.getItem(navigationPreferenceGateway.LOCAL_STORAGE_KEY));

                if (!currentPreferences) {
                    currentPreferences = {};
                }

                currentPreferences[navigationPreference.userId || 'anonymous'] = navigationPreference;

                localstorage.setItem(navigationPreferenceGateway.LOCAL_STORAGE_KEY, JSON.stringify(currentPreferences));

                if (persist && navigationPreference.userId) {
                    this.persist();
                }
            } catch (e) {
                //
            }
        };

        navigationPreferenceGateway._getPersistedFromApp = function (navigationPreferenceData) {
            var pref = core.getPreferences().navigationPreference;

            if (pref.consentCookieExpiredAt && pref.consentCookieExpiredAt > 0) {
                navigationPreferenceData.consentCookieExpiredAt = pref.consentCookieExpiredAt * 1000; // php seconds to milliseconds
                this.save(navigationPreferenceData);
            }

            return navigationPreferenceData;
        };

        navigationPreferenceGateway.persist = function () {
            $.post(router.ROUTES.ACCEPT_COOKIE);
        };

        navigationPreferenceGateway.hasCurrent = function (user) {
            var hasCurrent;

            try {
                hasCurrent = !!this.findCurrentByUser(user);
            } catch (e) {
                hasCurrent = false;
            }

            return hasCurrent;
        };

        return navigationPreferenceGateway;
    }
);
